import { IconProps } from './index';

const CloseFill: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10 8.822l4.125-4.125 1.178 1.178L11.178 10l4.125 4.125-1.178 1.178L10 11.178l-4.125 4.125-1.179-1.178L8.821 10 4.696 5.875l1.179-1.178L10 8.822z"
                fill="currentColor"
            />
        </svg>
    );
};

export default CloseFill;
